<template>

  <dialog_wheelDateChooser @submit="handleDateSubmit" v-if="datePickerShow" :default-date="tempDateForWheel" />
  <dialog_customerPicker @submit="handleCustomerSubmit" v-if="CustomerPickerVisible" />

  <ul class="suggestion" v-if="suggestion_showtype === 'purpose'" @mousedown.prevent>
    <li v-for="item in solution_purpose_list" v-bind:key="item">
      <span @click="selPurpose(item)">{{ item.value }}</span>
    </li>
  </ul>

  <div class="dialog">
    <span class="cls" @click="onOffFun(false)"></span>
    <div class="paper edit-solution" v-if="editingSolution?.client">
      <div class="header">
        <h1>솔루션 편집</h1>
        <span @click="onOffFun(false)">X</span>
      </div>
      <div>
        <label>솔루션 이름</label>
        <input type="text" v-model="editingSolution.name" placeholder="ex) 솔루션 A" />
      </div>
      <div>
        <label>유형</label>
        <select v-model="editingSolution.type">
          <option value="0">제안</option>
          <option value="1">분석</option>
        </select>
      </div>
      <div>
        <label>피보험자 이름</label>
        <input type="text" v-model="editingSolution.client.name" placeholder="ex) 홍길동" />
        <button class="load-btn" @click="CustomerPickerShow(true)">고객 불러오기</button>
      </div>
      <!-- <div>
        <label>피보험자 나이</label>
        <input type="text" @click="(e) => useDatePicker(true, e)" readonly v-model="editingSolution.client.birth" placeholder="ex) 45세" />
      </div>
      <div>
        <label>피보험자 성별</label>
        <select v-model="editingSolution.client.sex">
          <option value="0">무성</option>
          <option value="1">남성</option>
          <option value="2">여성</option>
        </select>
      </div> -->
      
      <!-- <div class="row">
        <div>
          <label>피보험자 주민번호 앞(6)자</label>
          <input type="text" v-model="firstCivNum" placeholder="ex) 123456" />
        </div>
        <div>
          <label>피보험자 주민번호 뒷(7)자</label>
          <input type="text" v-model="lastCivNum" placeholder="ex) 1234567" />
        </div>
      </div>
      <div class="row">
        <div>
          <label>보험료 방식</label>
          <select v-model="editingSolution.price_manual">
            <option :value="0">직접 작성</option>
            <option :value="1">자동 계산</option>
          </select>
        </div>
        <div v-if="editingSolution.price_manual == 0">
          <label>보험료</label>
          <input type="text" v-model="editingSolution.price" />
        </div>
      </div> -->
      <!-- <div>
        <label>작성일</label>
        <input type="date" v-model="editingSolution.created_at" readonly @click="(e) => useDatePicker(true, e)" />
      </div> -->
      <div>
        <label>컨설팅 목적</label>
        <input type="text" v-model="editingSolution.purpose" @focus="e => onFocus(e, 'purpose')" @blur="onBlur" placeholder="ex) 종합보험, 보장중심 등" />
      </div>
      <div class="btns">
        <!-- <button @click="onOffFun(false)">취소</button> -->
        <button @click="saveSolution" class="a">확인</button>
      </div>
    </div>
  </div>

</template>


<script>
import { inject, ref, onMounted } from "vue"
import { useBackButton } from '@/utils/useBackBtn';
import dialog_wheelDateChooser from '@/components/dialogs/wheelDateChooser.vue';
import dialog_customerPicker from '@/components/dialogs/customerPicker.vue';

export default {
  props: {
    onOffFun: Function,
    reLoadFunction: Function,
    solutionId: String,
  },
  components: {
    dialog_wheelDateChooser,
    dialog_customerPicker
  },
  setup(props) {
    
    const sql_query = inject('sql_query');
    const editingSolution = ref(null);

    const firstCivNum = ref('');
    const lastCivNum = ref('');

    useBackButton(() => {
      props.onOffFun(false);
    });
    onMounted(async () => {
      const result = await sql_query(`SELECT * FROM IS_solution WHERE idx = '${props.solutionId}'`);
      const raw = result?.[0];
      if (raw) {
        editingSolution.value = {
          idx: raw.idx,
          name: raw.name,
          client: raw.client ? JSON.parse(raw.client) : { id:'', age:'', sex:'0', name: '', civ_code: '' },
          created_at: raw.created_at?.slice(0, 10),
          status: raw.status,
          price: raw.price,
          price_manual: raw.price_manual || 0, // 수동 입력 가격
          customer_idx: raw.customer_idx || 0,
          purpose: raw.purpose || '',
          mb_id: raw.mb_id,
          type: raw.type,
        };
        firstCivNum.value = editingSolution.value.client.civ_code?.split('-')[0] || '';
        lastCivNum.value = editingSolution.value.client.civ_code?.split('-')[1] || '';
      }
    });

    const solution_purpose_list = [
      { value: '개인/종합', label: '종합보험' },
      { value: '개인/보장', label: '보장중심' },
      { value: '개인/저축', label: '저축중심' },
      { value: '개인/일반', label: '일반보험' },
      { value: '개인/기타', label: '기타보험' },
      { value: '가족/종합', label: '종합보험' },
      { value: '가족/보장', label: '보장중심' },
      { value: '가족/저축', label: '저축중심' },
      { value: '가족/일반', label: '일반보험' },
      { value: '가족/기타', label: '기타보험' },
      { value: '단체/종합', label: '종합보험' },
      { value: '단체/보장', label: '보장중심' },
      { value: '단체/저축', label: '저축중심' },
      { value: '단체/일반', label: '일반보험' },
      { value: '단체/기타', label: '기타보험' },
      { value: '기타/종합', label: '종합보험' },
      { value: '기타/보장', label: '보장중심' },
      { value: '기타/저축', label: '저축중심' },
      { value: '기타/일반', label: '일반보험' },
      { value: '기타/기타', label: '기타보험' },
    ];

    
    const plans = ref([]);

    async function fetchPlans() {
      const sql = `SELECT * FROM IS_plan ORDER BY idx DESC LIMIT 0, 30`;
      const result = await sql_query(sql);
      console.log('📦 가져온 저장된 플랜 목록:', result);

      // 예시: 가져온 데이터를 solutions 배열에 저장
      plans.value = result.map(row => ({
        wr_id: row?.idx,
        name: row?.name,
        company: row?.company,
        number: row?.number,
        pay: row?.pay,
        end: row?.end,
        price: row?.price,
        price_manual: row?.price_manual || 0, // 수동 입력 가격
        solution_id: row?.solution_id,
        created_at: row?.created_at,
        type: row?.type,
        sub_type: row?.sub_type,
      }));

      console.log('📦 플랜 목록:', plans.value);
    }

    onMounted(() => {
      fetchPlans();
    });
    
    const tempDateForWheel = ref(null);
    const dateInputTarget = ref(null);
    function useDatePicker(b, event) {
      datePickerShow.value = b;

      // 이벤트 디버깅
      console.log('event.target:', event?.target)

      const target = event?.target
      if (target instanceof HTMLInputElement) {
        dateInputTarget.value = target
        tempDateForWheel.value = target.value;
      } else {
        console.warn('event.target이 <input>이 아닙니다:', target)
        dateInputTarget.value = null
      }
    }

    function onFocus(e, name) {
      suggestion_showtype.value = name;

      const inputEl = e.target;

      setTimeout(() => {
        const suggestionEl = document.querySelector('ul.suggestion');
        if (suggestionEl && inputEl) {
          const rect = inputEl.getBoundingClientRect();

          // 스크롤 위치 보정 포함해서 suggestion 위치 설정
          suggestionEl.style.top = `${rect.top - 340 - 12 + window.scrollY}px`;
          suggestionEl.style.left = `${rect.left + window.scrollX}px`;
          suggestionEl.style.display = `flex`;
        }
      }, 100);
    }

    function onBlur() {
      suggestion_showtype.value = false;
    }

    function selPurpose(item) {
      if (editingSolution.value) {
        editingSolution.value.purpose = item.value;
        suggestion_showtype.value = false;
      }
    }
    
    function handleDateSubmit({ year, month, day }) {
      const inputEl = dateInputTarget.value
      if (inputEl instanceof HTMLInputElement) {
        const mm = String(month).padStart(2, '0')
        const dd = String(day).padStart(2, '0')
        inputEl.value = `${year}-${mm}-${dd}`
        inputEl.dispatchEvent(new Event('input'))
      } else {
        console.warn('날짜를 설정할 대상 input이 없습니다')
      }

      // ✅ 값 반영 후에 닫기
      useDatePicker(false)
    }

    
    async function saveSolution() {
      if (!editingSolution.value) return;

      const { idx, name, client, price, price_manual, created_at, purpose, customer_idx, type } = editingSolution.value;
      client.civ_code = `${firstCivNum.value}-${lastCivNum.value}`;
      const client_json = JSON.stringify(client).replace(/'/g, "\\'"); // 작은따옴표 escape

      let sql = `UPDATE IS_solution SET name = '${name || '제목 없음'}', client = '${client_json || '[]'}', customer_idx = '${customer_idx || 0}', price = '${price||0}', price_manual = '${price_manual || 0}', created_at = '${created_at || 'now()'}', purpose = '${purpose || '기타'}', type = '${type || 0}' WHERE idx = ${idx}`;
      console.log('📦 실행할 SQL:', sql);
      await sql_query(sql).then(() => {
          console.log('📦 솔루션이 수정되었습니다.');
          props.reLoadFunction(); // 여기에 맞춰 호출
        })
        .catch(error => {
          console.error('❌ 솔루션 수정 중 오류 발생:', error);
        });

      props.onOffFun(false);
    }

    const suggestion_showtype = ref(null);
    const datePickerShow = ref(false); // 날짜 선택기 사용 여부

    function formatDate(dateString) {
      const d = new Date(dateString);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      const ss = String(d.getSeconds()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
    }

    function getSolutionPrice(solution) {
      // plans에서 solution.idx에 해당하는 플랜을 찾아서 가격을 계산합니다.
      const relatedPlans = plans.value.filter(plan => plan.solution_id === solution.idx);
      if (relatedPlans.length === 0) {
        return "0원"; // 관련 플랜이 없으면 0원으로 표시
      }
      const totalPrice = relatedPlans.reduce((sum, plan) => sum + parseFloat(plan.price || 0), 0);
      return totalPrice; // 금액 포맷팅 후
    }

    let CustomerPickerVisible = ref(false);
    function CustomerPickerShow(bool) {
      CustomerPickerVisible.value = bool;
    }

    function handleCustomerSubmit({customer}) {
      console.log('📦 CustomerPickerShow:', customer);
      CustomerPickerShow(false);

      if (customer) {
        editingSolution.value.client = customer;
        editingSolution.value.customer_idx = customer.idx; 
      }
    }

    return {
      editingSolution,
      solution_purpose_list,
      suggestion_showtype,
      onFocus,
      onBlur,
      selPurpose,
      handleDateSubmit,
      useDatePicker,
      datePickerShow,
      tempDateForWheel,
      saveSolution,
      formatDate,
      getSolutionPrice,
      CustomerPickerShow,
      CustomerPickerVisible,
      handleCustomerSubmit,
      firstCivNum,
      lastCivNum
    }
  }
}
</script>


<style scoped>
#dialog-menu-main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}


ul.suggestion  {
  display:flex;
  display:none;
  position: absolute;
  width:40%;
  left:0;
  top:0;
  height: fit-content;
  max-height:300px;
  max-width:400px;
  overflow-y: scroll;
  flex-direction: column;
  gap: 6px;
  padding:12px;
  box-sizing: border-box;
  background: var(--color-background-light);
  border-radius: 8px;
  z-index: 999;
}

ul.suggestion > li {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:6px;
  box-sizing: border-box;
  border-radius:6px;
  cursor:pointer;
}

.dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  backdrop-filter: blur(2px);
}

.dialog > .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper > .header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between !important;
  align-items: center !important;
  flex-direction: row !important;
  font-size: var(--font-size-lg);
}

.dialog > .paper > .header > h1 {
  font-size:20px;
}

.dialog > .paper > .header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.dialog > .paper {
  width: 90%;
  max-width:600px;
  height: 100%;
  max-height:90%;
  overflow-y: scroll;
  background: var(--color-background);
  border:1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap:24px;
  display:flex;
  flex-direction: column;
}

.dialog > .paper > div {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.dialog > .paper > div label {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: start;
  align-items: center;
  box-sizing: border-box;
  border-radius:6px;
  cursor:pointer;
}

.dialog > .paper > div input {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:0 12px;
  box-sizing: border-box;
  background: var(--color-background-light);
}

.dialog > .paper > div select {
  width:100%;
  height:36px;
  border-radius:6px;
  border:none;
  padding:0 12px;
  box-sizing: border-box;
  background: var(--color-background);
  border:1px solid var(--color-surface-reverse);
}

.dialog > .paper > div > .load-btn {
  width:100%;
  display:flex;
  height:24px;
  background:none;
  border:none;
  cursor:pointer;
  color: var(--color-brand);
  text-decoration: underline;
}

.dialog > .paper > div.row {
  flex-direction: row;
}

.dialog > .paper > div.row > div {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.dialog > .paper > .btns {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap:12px;
}

.dialog > .paper > .btns > button {
  width: 100%;
  flex:1;
  height: 36px;
  background-color: var(--color-surface-reverse);
  color: var(--color-text-primary);
  font-size:14px;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  padding:0 12px;
  cursor: pointer;
}
.dialog > .paper > .btns > button.a {
  background-color: var(--color-brand);
  color: var(--color-text-black);
}

</style>
